import clsx from "clsx";
import React from "react";

import styles from "./Button.module.css";
import { LinkButtonProps } from "./Button.types";

/**
 * Looks like a [Button](?path=/docs/components-button--docs), but navigates to another page instead.
 *
 * It's important to use the correct one for a11y reasons, so when in doubt, ask.
 */
export const LinkButton: React.FC<LinkButtonProps> = ({
  label,
  href,
  newTab = false,
  appearance = "secondary",
  mode = "default",
  ...rest
}: LinkButtonProps) => (
  <a
    {...rest}
    data-testid="button"
    href={href || "#"}
    {...(newTab ? { target: "_blank", rel: "noopener noreferrer" } : {})}
    className={clsx(styles.button, styles[appearance], styles[mode])}
  >
    {label}
  </a>
);
